import React, { useState } from "react";
import MyTabs from "../../../tools/MyTabs";
import { Label } from "@mui/icons-material";
import {
  Check,
  CircleAlert,
  Globe,
  Image,
  Info,
  MessageSquareShare,
  Search,
  Upload,
} from "lucide-react";
import { Input } from "postcss";
import { SolidButton } from "../../../global/SolidButton";

export default function WebsiteSetting() {
  return (
    <>
      <div className="space-y-2 px-10 w-full">
        <div className="w-full mt-4 flex items-start justify-between space-x-4">
          {/* left section */}
          {/* ss */}
          <div className="flex flex-col w-full">
            <MyTabs
            position="left"
              tabs={[
                {
                  label: "Domain",
                  content: <Domain />,
                  icon: Globe,
                },
                {
                  label: "SEO",
                  content: <SEO />,
                  icon: Search,
                },
                {
                  label: "Social",
                  content: <Social />,
                  icon: MessageSquareShare,
                },
              ]}
            />
          </div>
          {/* right section */}
          <div className="flex flex-col items-center w-1/2">
            <div class="bg-gradient-to-br from-purple-50 to-blue-50 dark:from-purple-950/20 dark:to-blue-950/20 border border-purple-200 dark:border-purple-900/50 rounded-xl p-6">
              <h1 class="font-semibold text-sm text-purple-900 dark:text-purple-100 mb-4 flex items-center gap-2">
                <span class="text-sm">✨</span>SEO Best Practices
              </h1>
              <ul class="space-y-3 text-xs text-purple-800 dark:text-purple-200">
                <li class="flex items-start gap-2">
                  <span class="text-purple-600 dark:text-purple-400 mt-0.5 text-lg">
                    •
                  </span>
                  <span className="text-xs">
                    <strong className="text-xs">Title:</strong> Keep it between
                    50-60 characters for optimal display in search results
                  </span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-purple-600 dark:text-purple-400 mt-0.5 text-lg">
                    •
                  </span>
                  <span>
                    <strong>Description:</strong> Aim for 150-160 characters to
                    avoid truncation
                  </span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-purple-600 dark:text-purple-400 mt-0.5 text-lg">
                    •
                  </span>
                  <span>
                    <strong>Keywords:</strong> Use 5-10 relevant, high-volume
                    keywords
                  </span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-purple-600 dark:text-purple-400 mt-0.5 text-lg">
                    •
                  </span>
                  <span>
                    <strong>Favicon:</strong> Use 32×32px or 16×16px for best
                    compatibility
                  </span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-purple-600 dark:text-purple-400 mt-0.5 text-lg">
                    •
                  </span>
                  <span>
                    <strong>OG Image:</strong> Always use 1200×630px (1.91:1
                    ratio) for consistent display
                  </span>
                </li>
              </ul>
            </div>

            {/* protocol card */}
            <div className=" w-full mt-4  p-4 flex space-y-1 flex-col  bg-blue-400/10 rounded-lg border-1 border-blue-400">
              <div className="flex items-center justify-start text-blue-800 dark:text-blue-300 space-x-1">
                <Info className="w-4 h-4 " />
                <span className="text-xs font-bold">Open Graph Protocol</span>
              </div>
              <p className="text-[10px] font-normal font-sans text-blue-800 dark:text-blue-300 ">
                Open Graph tags control how your content appears when shared on
                social media platforms like Facebook, Twitter, and LinkedIn.
                They customize the title, description, and preview image to make
                your links more engaging and clickable.
              </p>
            </div>

            {/* configuration card */}
            <div className="w-full h-40 mt-4 p-4 flex flex-col rounded-lg border-[1px] border-gray-400/40">
              <span className="text-xs font-bold font-sans text-slate-800 dark:text-slate-200">
                Configuration Status
              </span>
              <div class="space-y-3 mt-3 text-[11px]">
                <div class="flex items-center justify-between">
                  <span class=" text-gray-600 dark:text-gray-400">Domain</span>
                  <span class=" font-medium text-green-600 dark:text-green-400">
                    ✓ Set
                  </span>
                </div>
                <div class="flex items-center justify-between">
                  <span class=" text-gray-600 dark:text-gray-400">
                    SEO Metadata
                  </span>
                  <span class=" font-medium text-gray-400">Incomplete</span>
                </div>
                <div class="flex items-center justify-between">
                  <span class=" text-gray-600 dark:text-gray-400">Favicon</span>
                  <span class=" font-medium text-gray-400">Not uploaded</span>
                </div>
                <div class="flex items-center justify-between">
                  <span class=" text-gray-600 dark:text-gray-400">
                    OG Image
                  </span>
                  <span class=" font-medium text-gray-400">Not uploaded</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const Domain = () => {
  return (
    <>
      {/* left section */}
      <div className="flex flex-col w-full mt-4">
        <div className="w-full   p-4 flex flex-col rounded-lg bg-white dark:bg-slate-300/20 border-1 border-gray-300/60 dark:border-gray-400/30">
          {/* top */}
          <div className="w-full space-x-2 text-blue-900 dark:text-blue-400 p-3 flex items-center justify-start bg-blue-50 dark:bg-blue-950/20 border-1 border-blue-400/30 rounded-lg">
            <CircleAlert className="w-8 h-8 p-1  bg-blue-400/20 rounded-md " />
            <div className="flex flex-col justify-center">
              <span className="text-xs   font-semibold">
                Domain Configuration
              </span>
              <span className="text-[10px] font-medium dark:text-blue-400 font-normal ">
                Set up your custom domain to make your landing page accessible
                via your own URL
              </span>
            </div>
          </div>
          <span className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800">
            Domain Name
          </span>

          <input
            type="text"
            name="damain"
            value={"Not Configured"}
            //onChange={handleChange}
            // placeholder="Not Configured"
            className={`w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700`}
          />
          <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
            Your custom domain for the landing page (e.g., myapp.com or
            app.mycompany.com)
          </span>
        </div>
      </div>
    </>
  );
};

export const SEO = () => {
  const [pageTitle, setPageTitle] = useState("");
  const [metaDes, setMetaDes] = useState("");
  return (
    <div className="flex flex-col w-full">
      {/* upload card */}
      <div
        className="w-full relative mt-4 p-5 flex flex-col rounded-lg
        bg-white dark:bg-slate-300/20 
        border border-gray-300/60 dark:border-gray-400/30"
      >
        <div className="flex items-center text-sm font-normal text-slate-600 dark:text-slate-300 space-x-1">
          <Image className="w-[16px] h-[16px]" />
          <span>Site Fav_icon</span>
        </div>

        <div
          className="py-4 mt-2 flex flex-col justify-center items-center 
          rounded-lg cursor-pointer hover:bg-gray-200/40 dark:hover:bg-gray-400/20
          border-dotted border-2 border-gray-300 hover:border-gray-700 dark:hover:border-slate-100"
        >
          <Upload className="w-10 h-10 p-3 rounded-full bg-gray-400/20 dark:bg-gray-500 text-slate-400 dark:text-slate-300" />
          <span className="text-[11px] text-slate-800 dark:text-slate-100 font-semibold mt-3">
            Click to upload favicon
          </span>
          <span className="text-[10px] mt-1 text-slate-800 dark:text-slate-100">
            PNG, JPG or ICO (max 100 KB)
          </span>

          <input
            type="file"
            accept=".json"
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />
        </div>
      </div>

      {/* form card */}
      <div
        className="w-full  mt-4 p-5 flex flex-col rounded-lg
        bg-white dark:bg-slate-300/20 
        border border-gray-300/60 dark:border-gray-400/30"
      >
        <span className="text-sm font-sans mt-4 text-slate-800 dark:text-slate-200">
          Page Title
        </span>

        {/* Input */}
        <input
          type="text"
          name="pageTitle"
          value={pageTitle ?? ""}
          onChange={(e) => setPageTitle(e.target.value.slice(0, 60))}
          placeholder="Your App Name - tagline"
          className="w-full  px-2 py-2 rounded-md 
          mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 
          dark:placeholder:text-slate-400
          focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
          border-[2px] border-slate-200 dark:border-slate-300/30"
        />

        {/* Bottom row */}
        <div className="flex items-center justify-between">
          <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
            Displayed in browser tab and search results
          </span>

          <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
            {pageTitle.length}/60
          </span>
        </div>

        <span className="text-sm font-sans mt-4 text-slate-800 dark:text-slate-200">
          Meta description
        </span>

        {/* Input */}
        <textarea
          type="text"
          name="pageTitle"
          value={metaDes ?? ""}
          onChange={(e) => setMetaDes(e.target.value.slice(0, 160))}
          placeholder="Brief description of your app..."
          className="w-full min-h-20 px-2 py-2 rounded-md 
          mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 
          dark:placeholder:text-slate-400
          focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
          border-[2px] border-slate-200 dark:border-slate-300/30"
        />

        {/* Bottom row */}
        <div className="flex items-center justify-between">
          <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
            Shown in search results
          </span>

          <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
            {metaDes.length}/160
          </span>
        </div>
        {/* ------------------------keyword--------------- */}
        <span className="text-sm font-sans mt-4 text-slate-800 dark:text-slate-200">
          Keywords
        </span>

        {/* Input */}
        <input
          type="text"
          name="pageTitle"
          value={metaDes ?? ""}
          //  onChange={(e) => setMetaDes(e.target.value.slice(0, 160))}
          placeholder="keyword 1,keyword2,keyword3"
          className="w-full  px-2 py-2 rounded-md 
          mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 
          dark:placeholder:text-slate-400
          focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
          border-[2px] border-slate-200 dark:border-slate-300/30"
        />

        {/* Bottom row */}
        <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
          Separate keywords with commas (5-10 keywords recommended)
        </span>
      </div>
      <div className="flex w-full items-center justify-end mt-4 pt-2 border-slate-400/20 border-t-1">
        <SolidButton>
          <Check className="w-4 h-4" />
          <span className="text-sm">Save Settings</span>
        </SolidButton>
      </div>
    </div>
  );
};

export const Social = () => {
  const [pageTitle, setPageTitle] = useState("");
  const [metaDes, setMetaDes] = useState("");
  return (
    <div className="flex flex-col w-full">
      {/* upload card */}
      <div
        className="w-full relative mt-4 p-5 flex flex-col rounded-lg
        bg-white dark:bg-slate-300/20 
        border border-gray-300/60 dark:border-gray-400/30"
      >
        <div className="flex items-center text-sm font-normal text-slate-600 dark:text-slate-300 space-x-1">
          <Image className="w-[16px] h-[16px]" />
          <span>Social Share Image</span>
        </div>

        <div
          className="py-4 h-80 mt-2 flex flex-col justify-center items-center 
          rounded-lg cursor-pointer hover:bg-gray-200/40 dark:hover:bg-gray-400/20
          border-dotted border-2 border-gray-300 hover:border-gray-700 hover:text-blue-500 dark:hover:border-slate-100"
        >
          <Image className="w-12 h-12 p-3 rounded-full bg-gray-400/20 hover:bg-blue-300/20 dark:bg-gray-500 text-slate-400 dark:text-slate-300" />
          <span className="text-[12px] text-slate-800 dark:text-slate-100 font-semibold mt-3">
            Upload Social Share Image
          </span>
          <span className="text-[12px] mt-1 text-slate-700 dark:text-slate-100">
            PNG or JPG (max 5MB, 1200×630px recommended)
          </span>

          <span className="text-xs mt-2 rounded-full m px-2 py-[2px] bg-slate-300/40 text-slate-800 dark:text-slate-100 font-normal">
            Aspect Ratio:1.91:1
          </span>
          <input
            type="file"
            accept=".jpeg || .png"
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />
        </div>
      </div>

      {/* form card */}
      <div
        className="w-full  mt-4 p-5 flex flex-col rounded-lg
        bg-white dark:bg-slate-300/20 
        border border-gray-300/60 dark:border-gray-400/30"
      >
        <span className="text-sm font-sans mt-4 text-slate-800 dark:text-slate-200">
          Social Title
        </span>

        {/* Input */}
        <input
          type="text"
          name="socialTitle"
          value={pageTitle ?? ""}
          onChange={(e) => setPageTitle(e.target.value.slice(0, 60))}
          placeholder="mon moooon"
          className="w-full  px-2 py-2 rounded-md 
          mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 
          dark:placeholder:text-slate-400
          focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
          border-[2px] border-slate-200 dark:border-slate-300/30"
        />

        {/* Bottom row */}
        <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
          Title shown when shared on social media (defaults to page title)
        </span>

        <span className="text-sm font-sans mt-4 text-slate-800 dark:text-slate-200">
          Social description
        </span>

        {/* Input */}
        <textarea
          type="text"
          name="socialDes"
          value={metaDes ?? ""}
          onChange={(e) => setMetaDes(e.target.value.slice(0, 160))}
          placeholder="Leave empty to use meta description"
          className="w-full min-h-20 px-2 py-2 rounded-md 
          mt-1 text-slate-900 dark:text-white text-xs placeholder-slate-500 
          dark:placeholder:text-slate-400
          focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
          border-[2px] border-slate-200 dark:border-slate-300/30"
        />

        {/* Bottom row */}

        <span className="text-[10px] mt-1 text-slate-500 dark:text-slate-400">
          Description in social media preview (defaults to meta description)
        </span>

       

    
      </div>
      <div className="flex w-full items-center justify-end mt-4 pt-2 border-slate-400/20 border-t-1">
        <SolidButton>
          <Check className="w-4 h-4" />
          <span className="text-sm">Save Settings</span>
        </SolidButton>
      </div>
    </div>
  );
};
